import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import RevenueTargetingModelList from "../../components/RevenueTargetingModelList";
import CompanyList from "../../components/CompanyList";
import EditRevenueTargetingModel from "../../components/EditRevenueTargetingModel";
import { getRevenueTargetingModels } from "../../services/RevenueTargetingModels";
import AuthContext from "../../context/AuthContext";
import EmptyPage from "../../components/EmptyPage";

export default function Dashboard({ page }) {
  const [revenueTargetingModels, setRevenueTargetingModels] = useState([]);
  const [selectedRevenueTargetingModel, setSelectedRevenueTargetingModel] =
    useState({});
  const [selectedRevenueTargetingModelID, setSelectedRevenueTargetingModelID] =
    useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const auth = useContext(AuthContext);

  const location = useLocation();

  const navigate = useNavigate();

  const { id } = useParams();

  const getModels = (redirectToEdit = false) => {
    setIsLoading(true);
    setRevenueTargetingModels([]);
    setSelectedRevenueTargetingModel({});
    setSelectedRevenueTargetingModelID(0);

    getRevenueTargetingModels(auth.token)
      .then((response) => {
        let found = false;
        let account = auth.userAccountID;
        if (response.revenue_targeting_models.length > 0) {
          found = response.revenue_targeting_models.find(
            (revenueTargetingModel) => revenueTargetingModel.id === Number(id)
          );

          if (found) {
            auth.setUserAccountID(found.account);
            account = found.account;
            setSelectedRevenueTargetingModel(found);
            setSelectedRevenueTargetingModelID(found.id);
          }
        }

        response.revenue_targeting_models =
          response.revenue_targeting_models.filter(
            (rtm) => rtm.account === account
          );

        response.revenue_targeting_models.sort((a, b) => {
          if (Number(a.active) - Number(b.active) === 0) {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          } else {
            return -(Number(a.active) - Number(b.active));
          }
        });

        setRevenueTargetingModels(response.revenue_targeting_models);

        if (redirectToEdit) {
          const newestModelID = Math.max.apply(
            Math,
            response.revenue_targeting_models.map(function (o) {
              return o.id;
            })
          );
          navigate(`/model/${newestModelID}/edit`);
        } else if (
          (location.pathname === "/" || !found) &&
          response.revenue_targeting_models[0]
        ) {
          navigate(`/model/${response.revenue_targeting_models[0].id}`);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getModels();
  }, []);

  // prevents an update on the first run
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    navigate("/model");
  }, [auth.userAccountID]);

  useEffect(() => {
    if (location.pathname === "/model") {
      getModels();
    }
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/") {
      getModels();
    }
  }, [location]);

  useEffect(() => {
    if (id) {
      let found = false;
      const revenueTargetingModel = revenueTargetingModels.find(
        (revenueTargetingModel) => revenueTargetingModel.id === Number(id)
      );
      if (revenueTargetingModel) {
        setSelectedRevenueTargetingModel(revenueTargetingModel);
        setSelectedRevenueTargetingModelID(Number(id));
        found = true;
      }
      if (!found) {
        setSelectedRevenueTargetingModel([0] || {});
        setSelectedRevenueTargetingModelID(
          revenueTargetingModels[0] ? revenueTargetingModels[0].id : 0
        );
      }
    }
  }, [id]);

  return (
    <Layout
      sidebar={
        <RevenueTargetingModelList
          revenueTargetingModels={revenueTargetingModels}
          selectedRevenueTargetingModelID={selectedRevenueTargetingModelID}
          loading={isLoading}
          getModels={getModels}
        />
      }
      title={
        selectedRevenueTargetingModel ? selectedRevenueTargetingModel.name : ""
      }
      modelID={
        selectedRevenueTargetingModel ? selectedRevenueTargetingModel.id : 0
      }
      getModels={getModels}
      page={page}
      main={
        page === "edit" ? (
          <EditRevenueTargetingModel
            revenueTargetingModelID={
              selectedRevenueTargetingModelID
                ? selectedRevenueTargetingModelID
                : 0
            }
            getModels={getModels}
          />
        ) : // TODO: update this to show a different page
        selectedRevenueTargetingModelID ? (
          <CompanyList
            revenueTargetingModelID={
              selectedRevenueTargetingModel
                ? selectedRevenueTargetingModel.id
                : 0
            }
            activeModel={
              selectedRevenueTargetingModel
                ? selectedRevenueTargetingModel.active
                : false
            }
          />
        ) : (
          <EmptyPage />
        )
      }
    />
  );
}
